import { PersistentFormArray, PersistentFormGroup } from '@utility/persistent-forms';
import { SingleStipendVisitFormGroup } from './single-stipend-visit/single-stipend-visit.form';

export class StipendVisitsFormGroup extends PersistentFormGroup<{
    stipendVisits: PersistentFormArray<SingleStipendVisitFormGroup>;
}> {
    constructor() {
        super({
            stipendVisits: new PersistentFormArray<SingleStipendVisitFormGroup>([]),
        });
    }
}
